<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin()"
  [cdkConnectedOverlayOpen]="show()"
  [cdkConnectedOverlayFlexibleDimensions]="true"
  [cdkConnectedOverlayPositions]="positions()"
  [cdkConnectedOverlayViewportMargin]="viewportMargin()"
>
  <div
    pluginsFocusContainer
    [focusOutsideDirectiveRef]="focusOutsideDirectiveRef()"
  >
    <div cdkTrapFocus [cdkTrapFocusAutoCapture]="autofocus()">
      <div
        class="overlay-container"
        [class.withClose]="showClose()"
        [style.max-width]="maxWidth()"
        [style.max-height]="maxHeight()"
        #componentWrapper
      >
        <div (cdkObserveContent)="handleContentChange()">
          <ng-content />
        </div>
        @if (showClose()) {
          <plugins-shared-button
            size="sm"
            variant="secondary-text"
            [class.with-scrollbar]="hasScrollbar()"
            [title]="'overlay.container.close' | translate"
            [ariaLabel]="'overlay.container.close' | translate"
            (clicked)="handleClose()"
          >
            <icon-cancel />
          </plugins-shared-button>
        }
      </div>
    </div>
  </div>
</ng-template>
